import { ObjectiveType } from '@/features/actions/logic/types'

export const objectiveTypeToVerb: Record<ObjectiveType, string> = {
  deposit: 'Deposited',
  borrow: 'Borrowed',
  withdraw: 'Withdrew',
  repay: 'Repaid',
  setUseAsCollateral: 'Set',
  setUserEMode: 'Set',
  depositToSavings: 'Converted',
  withdrawFromSavings: 'Converted',
  claimMarketRewards: 'Claimed',
  upgradeSdai: 'Upgraded',
  stake: 'Deposited',
  unstake: 'Withdrew',
  claimFarmRewards: 'Claimed',
  swap: 'Swapped',
  claimSparkRewards: 'Claimed',
  stakeSpk: 'Staked',
  unstakeSpk: 'Unstaked',
  finalizeSpkUnstake: 'Claimed',
  claimAirdropRewards: 'Claimed',
  delegate: 'Set delegate',
  undelegate: 'Cleared delegate',
  claimPointsRewards: 'Claimed',
  depositToWeth: 'Wrapped',
  withdrawFromWeth: 'Unwrapped',
  upgradeSusdc: 'Upgraded',
}
